import { BenefitWizardType } from 'src/app/constants/wizard-panels';

export class BenefitWizardControlPanel {
    panel: string;
    benefitNumber: number;
    uniqueID: string;
    enrollmentName: string;
    headerPrefix: string;
    wizardType: BenefitWizardType;

    constructor(){
        this.panel = null;
        this.benefitNumber = 0;
        this.uniqueID = null;
        this.enrollmentName = null;
        this.headerPrefix = null;
        this.wizardType = BenefitWizardType.None;
    }
}